module.exports = __webpack_public_path__ + "static/media/bin.cdb96cce.svg";